import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { PropTypes } from 'prop-types';

// Parametros props
//id: Id identificador del componente
//name: nombre identificador del componente
//title: Título del agrupador
//items: opciones a elegir [{label: 'TI', title: 'TI'}]
//handleChange: Función que retorna los cambios del componente
//value: Valor seleccionado


Radios.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

Radios.defaultProps = {
  id: 'Custom',
  name: 'Custom',
  title: 'Custom',
  items: [{ value: 'TI' }, { value: 'HP' }],
  onChange: () => { },
  value: 'TI',
}

function Radios(props) {
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend" style={{ fontWeight: 'bold', width: "100%", textAlign: "center" }}>{props.title}</FormLabel>
      <RadioGroup row aria-label={props.name} name={props.name} className="center" defaultValue="center" value={props.value} onChange={props.onChange}>
        {
          props.items.map((item, index) => {
            if (item.Msg !== undefined) {
              return (<Tooltip title={item.Msg} placement="bottom">
                <FormControlLabel key={item.value} value={item.value} control={<Radio color="primary" />} label={item.value} labelPlacement="top" />
              </Tooltip>)
            } else {
              return (<FormControlLabel key={item.value} value={item.value} control={<Radio color="primary" />} label={item.value} labelPlacement="top" />)
            }
          })
        }
      </RadioGroup>
    </FormControl>
  );
}

/* retorna true si al pasar los nextProps a renderizar retorna el mismo resultado que al pasar los prevProps a renderizar, de otro modo retorna false */
function validaProps(prevProps, nextProps) {
  //si retorna un falso renderiza todo el componente, porque si es falso significa que el valor cambio
  //falso es igual que son diferentes
  //si son muchos objetos va si [0]
  return (prevProps.value === nextProps.value);
}

export default React.memo(Radios, validaProps);
